import * as React from 'react';
import { Typography } from '../Typography';
import { createLocators } from '@u1/locators';
import useStyles from './Breadcrumbs.styles';

export const breadcrumbsLocators = createLocators({
  name: 'Breadcrumbs',
  componentLocators: ['breadcrumbs'],
});
const { locators } = breadcrumbsLocators();

const Breadcrumbs: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const classes = useStyles();

  return (
    <Typography
      as="div"
      className={classes.wrapper}
      locatorsOverrides={locators.breadcrumbs()}
    >
      {children}
    </Typography>
  );
};

export default Breadcrumbs;
